import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "product-card card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "product-details" }
const _hoisted_4 = ["viewBox"]
const _hoisted_5 = ["y"]
const _hoisted_6 = { class: "text-nowrap fs-4" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"red","font-weight":"bold"}
}
const _hoisted_8 = {
  key: 1,
  class: "product-amount"
}

import btnOutlinePrimary from "@/components/btn-outline-primary.vue";
import btnOutlineSecondary from "@/components/btn-outline-secondary.vue";
import { CartProduct, useCartStore } from '@/store/CartStore';
import { computed, ComputedRef, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderProductItem',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: CartProduct
};




const cartStore = useCartStore();
function amountIncr(product: CartProduct) {
    cartStore.increaseAmount(product.id);
}

function amountDecr(product: CartProduct) {
    cartStore.decreaseAmount(product.id);
}

function remToPx(rem: number): number {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

const titleText = ref<SVGElement>();
const productName = ref<Element>();
const textWidth: ComputedRef<number> = computed(() => {
    return (titleText.value?.clientWidth ?? 0) * window.devicePixelRatio;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "product-img",
      src: __props.product.imageUrl
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, [
        (_openBlock(), _createElementBlock("svg", {
          viewBox: '0 0 ' + _unref(textWidth) + ' ' + remToPx(2),
          class: "product-name me-2",
          style: _normalizeStyle('max-width:' + _unref(textWidth) + 'px')
        }, [
          _createElementVNode("text", {
            ref_key: "titleText",
            ref: titleText,
            x: "0",
            y: remToPx(1.3),
            class: "fs-4 me-5"
          }, _toDisplayString(__props.product.name), 9, _hoisted_5)
        ], 12, _hoisted_4)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.product.price.toFixed(2)) + " Kč", 1)
      ]),
      (!__props.product.isAvailable)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Není k dispozici"))
        : _createCommentVNode("", true),
      (__props.product.isAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(btnOutlinePrimary, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (amountDecr(__props.product)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("-")
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(__props.product.amount), 1),
            _createVNode(btnOutlinePrimary, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (amountIncr(__props.product)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("+")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})